export default {
  labels: {
    open: 'Mostrar artigos',
    collapse: 'Fechar artigos',
    in_stock: 'Em Stock',
    out_of_stock: 'Sem stock',
    visible: 'Visível no menu',
    hidden: 'Oculto do menu',
  },
  list: {
    name: 'Item do menu',
    price: 'Preço',
    is_available: 'EM STOCK/SEM STOCK',
  },
};
